import React from "react";
import { Tooltip as MuiTooltip } from "@mui/material";

interface CustomTooltipProps {
  title: string;
  children: React.ReactElement;
  placement?:
    | "top"
    | "top-start"
    | "top-end"
    | "bottom"
    | "bottom-start"
    | "bottom-end"
    | "left"
    | "left-start"
    | "left-end"
    | "right"
    | "right-start"
    | "right-end";
}

export const Tooltip: React.FC<CustomTooltipProps> = ({
  title,
  children,
  placement = "top-start",
}) => {
  return (
    <MuiTooltip
      title={title}
      placement={placement}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -22], // Adjust for vertical positioning
              },
            },
          ],
        },
      }}
    >
      {children}
    </MuiTooltip>
  );
};
